import * as React from 'react';
import { useAdyen } from '../../../context/Adyen/context.js';
import '../../../context/PaymentsUI/context.js';
import '@swc/helpers';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { getPaymentImplementation, getPaymentMethodSettings } from '../Payments/providers.js';

const usePaymentMethodForm = (handleGpayCtaClick, onAuthorize)=>{
    const { config  } = useAdyen();
    const [selectedPaymentDetails, setSelectedPaymentDetails] = React.useState();
    const handlePaymentDataChange = React.useCallback((paymentData, isValid)=>{
        setSelectedPaymentDetails({
            data: paymentData,
            isValid
        });
    }, []);
    const resetPaymentDetails = React.useCallback(()=>{
        setSelectedPaymentDetails(undefined);
    }, []);
    const renderPaymentForm = React.useCallback((selectedPaymentMethod)=>{
        if (!selectedPaymentMethod) {
            return null;
        }
        const implementation = getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
        // Get settings that are passed to payment settings provider from the OpCo site
        const settings = getPaymentMethodSettings(selectedPaymentMethod.provider, selectedPaymentMethod.type, config);
        if (!implementation || !implementation.form) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(implementation.form, {
            onChange: handlePaymentDataChange,
            onClick: handleGpayCtaClick,
            onAuthorize,
            config: selectedPaymentMethod.config,
            settings
        });
    }, [
        config,
        handleGpayCtaClick,
        handlePaymentDataChange,
        onAuthorize
    ]);
    return React.useMemo(()=>[
            renderPaymentForm,
            selectedPaymentDetails,
            resetPaymentDetails
        ]
    , [
        renderPaymentForm,
        selectedPaymentDetails,
        resetPaymentDetails
    ]);
};

export { usePaymentMethodForm };
//# sourceMappingURL=use-payment-method-form.js.map
